@import '~style-sheet-helpers/core.less';

.rejected-banner__title,
.rejected-banner__help-text {
  margin: 0;
}

.rejected-banner__help-text {
  font-size: 13px !important;
}

.rejected-banner__title {
  font-size: 14px !important;
  font-weight: 500 !important;
}
